// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"24":"tkdetail","776":"tklist"}[chunkId] + "." + {"24":"4bc4fe0b","776":"47b5a87c"}[chunkId] + ".css";
};